<template>
  <div>
    <span v-for="(item,index) in itemClasslass"
          class="star-item"
          :key="index"
          :class="item"
          @click="stars(index)"></span>
  </div>
</template>

<script>
  const lengths = 5;
  const starOn = "on";
  const starOff = "off";
  export default {
    date() {
      return {
        lengths: 5,
        starOn: "on",
        starOff: "off",
        gradetemp,
        eventHub: new Vue(),
       

      }
    },
    computed: {
      itemClasslass() {
        //星星的数组
        let result = [];
        let gradetemp = Math.floor(this.grade * 2) / 2;
        //几颗全星
        let fullstar = Math.floor(this.grade);
        for (var i = 0; i < this.grade; i++) {
          //放全空星
          result.push(starOn);
        }

        if (result.length < lengths) { 
          //全部实星
          var offstar = lengths - result.length;
          for (var i = 0; i < offstar; i++) {
            result.push(starOff);
          }
        }
        return result;
      }
    },
    methods: {
      stars: function (index) {
        
        let that =this;
        that.gradetemp = that.grade;
        that.gradetemp = index + 1;
        // if(that.startcon.every(item => item === index)){
          
        // }
        //  that.startcon.forEach((item, index) => {
        //     if(index==that.gradetemp){
            //    return  item 
            //   that.tempstartcon=item;
            // console.log(that.tempstartcon)
        //     }  
        // });
       
        that.$emit('gradeDtae', { 'gradetemp': that.gradetemp, 'GUID': that.id });
      }
    },
    props: ["grade", "id"] //获取父组件传递过来的评分参数
  };
</script>

<style>
  .star {
    font-size: 0;
  }

  .star-item {
    display: inline-block;
    background-repeat: no-repeat;
    width: 0.4rem;
    height: 0.42rem;
    margin-right: 0.22rem;
    background-size: 100%;
  }

    .star-item.on {
      background-image: url(../../assets/images/star2.png);
    }

    .star-item.off {
      background-image: url(../../assets/images/star1.png);
    }
</style>



// WEBPACK FOOTER //
// src/components/satisfaction/star.vue